import { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const ThemeCtx = createContext(null);

const DEFAULT = {
  primary: "#C5A059", primary_hover: "#B38F4D",
  bg_soft: "#FDFBF7", bg_tertiary: "#F5F2EA", text: "#111111",
  heading_font: "Playfair Display", body_font: "Outfit",
};

function applyTheme(t) {
  const r = document.documentElement.style;
  r.setProperty("--gold", t.primary);
  r.setProperty("--gold-hover", t.primary_hover);
  r.setProperty("--bg-soft", t.bg_soft);
  r.setProperty("--bg-tertiary", t.bg_tertiary);
  r.setProperty("--text", t.text);
  // Inject font links if needed
  const fontFamilies = [t.heading_font, t.body_font].filter(Boolean);
  fontFamilies.forEach((f) => {
    const id = `gf-${f.replace(/\s+/g, "-")}`;
    if (!document.getElementById(id)) {
      const link = document.createElement("link");
      link.rel = "stylesheet"; link.id = id;
      link.href = `https://fonts.googleapis.com/css2?family=${encodeURIComponent(f).replace(/%20/g, "+")}:wght@300;400;500;600;700&display=swap`;
      document.head.appendChild(link);
    }
  });
  document.documentElement.style.setProperty("--font-heading", `'${t.heading_font}', Georgia, serif`);
  document.documentElement.style.setProperty("--font-body", `'${t.body_font}', system-ui, sans-serif`);
}

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(DEFAULT);

  const refresh = async () => {
    try {
      const { data } = await api.get("/theme");
      const merged = { ...DEFAULT, ...data };
      setTheme(merged); applyTheme(merged);
    } catch {
      applyTheme(DEFAULT);
    }
  };

  useEffect(() => { refresh(); }, []);

  const update = async (patch) => {
    const { data } = await api.patch("/admin/theme", patch);
    const merged = { ...DEFAULT, ...data };
    setTheme(merged); applyTheme(merged);
    return merged;
  };

  return <ThemeCtx.Provider value={{ theme, update, refresh }}>{children}</ThemeCtx.Provider>;
}

export const useTheme = () => useContext(ThemeCtx);
